export default {
    getFields(Selector) {
        return {
            "password": {required: true},
            "repassword": {required: true}
        }
    }
}export default {
    getFields(Selector) {
        return {
            "password": {required: true},
            "repassword": {required: true}
        }
    }
}